var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings default-container"},[_c('back-link',{staticClass:"mb-5",attrs:{"text":_vm.$t('main.header.links.settings')}}),_c('SubscriptionList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }